export default function () {
    var isTouchScreen = false;

    // Check device
    (function () {
        if ('ontouchstart' in document.documentElement) {
            isTouchScreen = true;
        }
    })();

    if (isTouchScreen) {
        document.addEventListener('touchend', function (event) {
            toggleItem(event);
        });
    } else {
        document.addEventListener('click', function (event) {
            toggleItem(event);
        });
    }

    function toggleItem(event) {
        var el = document.querySelector('.c-carousel__item.active');

        if (!event.target.matches('.c-carousel__item.inactive')) return;
        event.preventDefault();
        event.target.classList.toggle('active');
        event.target.classList.toggle('inactive');
        el.classList.toggle('active');
        el.classList.toggle('inactive');
    }
}
